export const GET_ORDINANCE_REVISION_EFFECTIVITY = 'GET_ORDINANCE_REVISION_EFFECTIVITY/get_ordinance_revision_effectivity';
export const GET_FORMDATA_ORDINANCE_REVISION = 'GET_FORMDATA_ORDINANCE_REVISION/get_formdata_ordinance_revision'
export const GET_FORMDATA_ORDINANCE_REVISION_DEFAULT = 'GET_FORMDATA_ORDINANCE_REVISION_DEFAULT/get_formdata_ordinance_revision_default'
export const GET_REPORTS = 'module_distribution/get_reports';
export const GET_REPORT_LIST = 'module_distribution/get_report';
export const GET_PREVIEW_LINK = 'module_distribution/get_preview_link';
export const GET_REVENUE_REPORT_LIST = 'module_distribution/get_revenue_report_list';

// export const Reports_URI = 'api/v1/administrators/report_file_exports_download/{id}/preview';
export const BPLS_MODULE_TYPE = [
  { label: 'E-Boss', value: 'T_BPLS'},
  { label: 'Go! BPLS', value: 'BPLS'},
]
